import type { JSX } from "preact";
import { Transforms } from "slate";
import type { RenderElementProps } from "slate-react";
import { ReactEditor, useSlateStatic } from "slate-react";
import { Remove } from "../components/icons";
import { ButtonIcon } from "./ButtonIcon";
import type { ImageElement } from "./types";

interface Parameters extends RenderElementProps {
    element: ImageElement;
}

export function Image({
    element,
    attributes,
    children,
}: Parameters): JSX.Element {
    const editor = useSlateStatic();
    const title = element.children.map((c) => c.text).join(" ") || undefined;

    return (
        <div {...attributes}>
            {children}
            <div contentEditable={false} className="position-relative">
                <img src={element.src} title={title} alt={title} />

                {!ReactEditor.isReadOnly(editor) && (
                    <ButtonIcon
                        active
                        icon={Remove}
                        onClick={(event) => {
                            event.preventDefault();
                            const path = ReactEditor.findPath(editor, element);
                            Transforms.removeNodes(editor, { at: path });
                        }}
                    />
                )}
            </div>
        </div>
    );
}
